import { render, staticRenderFns } from "./Paypoint.vue?vue&type=template&id=26c5827a"
import script from "./Paypoint.vue?vue&type=script&lang=js"
export * from "./Paypoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports